<template>
  <div class="solution">
    <div class="solution-top">
      <div class="solution-top-left">
        <div class="title">解决方案</div>
        <div class="titleEn">Solution</div>
      </div>
      <div class="solution-top-right">
        <div class="btn" @click="showNumChange('per')">
          <img :src="iconLeft" />
        </div>
        <div class="btn" @click="showNumChange('next')">
          <img :src="iconRight" />
        </div>
      </div>
    </div>
    <div class="solution-content">
      <div class="solution-content-left" @click="tarDetail(showData)">
        <div class="img">
          <img :src="getIconPath(showData.img3)" />
        </div>
        <div class="title">{{ showData.title }}</div>
        <div class="content">
          {{ showData.content[1].value }}
        </div>
      </div>
      <div class="solution-content-right">
        <div class="box" @mouseover="stopimg" @mouseleave="startimg">
          <div
            @click="tarDetail(item)"
            class="box-div"
            v-for="(item, index) in solutionList"
            :key="index"
          >
            <div class="box-div-imgs">
              <img :src="getIconPath(item.img2)" />
            </div>
            <div class="box-div-content">
              <div class="title">{{ item.title }}</div>
              <div class="content">{{ item.content[1].value }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import iconLeft from "@/assets/img/icon_left.png";
import iconRight from "@/assets/img/icon_right.png";
import {
  data1,
  data2,
  data3,
  data4,
  data5,
} from "@/components/pageDetail/config/solutionConfig";
export default {
  name: "homeSolution",
  data() {
    return {
      iconLeft,
      iconRight,
      solutionList: [data1, data2, data3, data4, data5],
      num: 0,
      theDirection: "left",
      imgWidth: 226,
      timer: null,
      theSpeed: 2,
      showNum: 0,
      showData: null,
    };
  },
  methods: {
    startimg() {
      let imgBox = document.getElementsByClassName("box")[0];
      this.num++;
      if (this.num == 1) {
        //将imgBox下的图片进行拼接 循环展示图片
        imgBox.innerHTML += imgBox.innerHTML;
        let self = this;
        let imgDiv = document.getElementsByClassName("box-div");
        let imgs = Array.from(imgDiv);
        imgs.forEach((item, index) => {
          item.addEventListener("click", function () {
            // self.tarpage(self.imgList[index].homeText);
            self.changeNum(index);
          });
        });
      }
      let self = this;
      let imgDiv = document.getElementsByClassName("box-div");
      // let imgs = Array.from(imgDiv);
      //   imgBox.style.height = (imgDiv.length * this.imgWidth) / 16 + "rem"; //设置div的宽度使图片可以放下
      imgBox.style.height = imgDiv.length * this.imgWidth + "px"; //设置div的宽度使图片可以放下
      // let self = this;
      function autoScroll() {
        if (imgBox.offsetTop < -(imgBox.offsetHeight / 2)) {
          //提前更新left值，实现循环展示
          imgBox.style.top = 0;
        }
        if (imgBox.offsetTop > 0) {
          //向右滚动 提前更新left值，实现循环展示
          imgBox.style.top = -(imgBox.offsetHeight / 2) + "px";
        }
        //向左滚动,值为负
        self.theSpeed = -Math.abs(self.theSpeed);
        // 求出总的left值，等于left值加上移动的速度（px值）
        imgBox.style.top = imgBox.offsetTop + self.theSpeed + "px";
      }
      this.timer = setInterval(autoScroll, 30); //全局变量 ，保存返回的定时器
    },
    stopimg() {
      clearInterval(this.timer);
      this.timer = null;
    },
    showNumChange(val) {
      if (val == "per") {
        if (this.showNum == 0) {
          this.showNum = this.solutionList.length - 1;
        } else {
          this.showNum--;
        }
      } else {
        if (this.showNum == this.solutionList.length - 1) {
          this.showNum = 0;
        } else {
          this.showNum++;
        }
      }
      this.getDataList();
    },
    changeNum(index) {
      console.log(index);
      let showNum = null
      if (index > 4) {
        showNum = index - 5;
      } else {
        showNum = index;
      }
      // this.getDataList();
      this.tarDetail(this.solutionList[showNum])
    },
    // getIconPath(iconName) {
    //   return require(`@/assets/img/${iconName}.png`);
    // },
    tarDetail(item){
      console.log(item);
      this.$router.push({
        path: "/solutionDetail",
        query: { type: item.type,},
      });
    },
    getIconPath(iconName) {
      return require(`@/assets/img/solution/${iconName}.png`);
    },
    getDataList() {
      if (this.showNum == 0) {
        this.showData = data1;
      } else if (this.showNum == 1) {
        this.showData = data2;
      } else if (this.showNum == 2) {
        this.showData = data3;
      } else if (this.showNum == 3) {
        this.showData = data4;
      } else if (this.showNum == 4) {
        this.showData = data5;
      }
    },
  },
  created() {
    this.getDataList();
  },
  mounted() {
    setTimeout(() => {
      //需要定时执行的代码
      // console.debug("Hello World");
      this.startimg();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="scss" scoped>
.solution {
  padding: 110px 260px 30px 260px;
  &-top {
    display: flex;
    justify-content: space-between;
    &-left {
      .title {
        font-size: 24px;
        // font-weight: bold;
      }
      .titleEn {
        margin-top: 10px;
        font-size: 24px;
        color: #999;
      }
    }
    &-right {
      display: flex;
      .btn {
        width: 32px;
        height: 32px;
        margin-left: 10px;
        background-color: #004f6a;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        img {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
  &-content {
    display: flex;
    justify-content: space-between;
    margin-top: 58px;
    &-left {
      width: 680px;
      .img {
        width: 100%;
        height: 488px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.25s ease-in;
        }
        img:hover {
          transform: scale(1.1, 1.1);
          transition: all 0.25s ease-in;
        }
      }
      .title {
        margin-top: 36px;
        font-size: 24px;
      }
      .content {
        margin-top: 10px;
        font-size: 15px;
        color: #666;
        line-height: 28px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    &-right {
      width: calc(100% - 720px);
      height: 642px;
      overflow: hidden;
      position: relative;
      .box {
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        overflow: hidden;
        &-div {
          display: flex;
          margin-top: 32px;
          cursor: pointer;
          &-imgs {
            width: 320px;
            height: 226px;
            overflow: hidden;
            img {
              width: 100%;
              height: 100%;
              // width: 320px;
              // height: 226px;
              transition: all 0.25s ease-in;
            }
            img:hover {
              transform: scale(1.1, 1.1);
              transition: all 0.25s ease-in;
            }
          }
          &-content {
            margin-left: 40px;
            margin-top: 64px;
            width: calc(100% - 360px);
            .title {
              font-size: 20px;
            }
            .content {
              margin-top: 24px;
              font-size: 15px;
              color: #666;
              display: -webkit-box;
              -webkit-line-clamp: 5;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 28px;
            }
          }
        }
        &-div:first-child {
          margin-top: 0;
        }
      }
    }
  }
}
</style>